<template>
  <div class="cta-default">
    <Link v-if="data.link" :link="data.link" class="button-primary" icon-position="left" />
  </div>
</template>

<script setup lang="ts">
import type { CtaDefaultFragment } from '#gql';
import Link from '~/components/content-modules/components/Link.vue';

defineProps<{
  data: CtaDefaultFragment;
}>();
</script>

<style scoped lang="scss">
.cta-default {
  margin-bottom: var(--spacing-3xl);
}
</style>
